import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
  CircularProgress,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ThemeProvider } from '@mui/material/styles';
import logo from '../assets/logo.jpg'; // Assuming you have the logo in assets
import theme from '../theme';

interface LoginFormProps {
  onLogin: (email: string, pass: string) => void;
  error: string;
  isLoading: boolean;
}

const LoginForm: React.FC<LoginFormProps> = ({ onLogin, error, isLoading }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onLogin(email, password);
  };

  const toggleShowPassword = () => setShowPassword((prev) => !prev);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          width: '100%',
          maxWidth: '400px',
          backgroundColor: '#FFFFFF',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          padding: '2rem',
          textAlign: 'center',
          height: 'fit-content',
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Asht Detect Logo"
          sx={{
            width: '100%',
            height: 'auto',
            maxWidth: '200px',
            marginBottom: '1rem',
          }}
        />
        <Typography
          variant="subtitle1"
          component="p"
          color="text.secondary"
          gutterBottom
        >
          Ingresa las credenciales para iniciar sesión!
        </Typography>
        <form
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem',
            marginTop: '1rem',
          }}
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <TextField
            fullWidth
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            fullWidth
            label="Contraseña"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={toggleShowPassword}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {error && typeof error === 'string' && (
            <Typography color="error">{error}</Typography>
          )}
          {isLoading ? (
            <Box display="flex" justifyContent="center">
              <CircularProgress color="inherit" />
            </Box>
          ) : (
            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              sx={{
                fontWeight: 500,
                textTransform: 'none',
              }}
              type="submit"
            >
              Iniciar Sesión
            </Button>
          )}
        </form>
      </Box>
    </ThemeProvider>
  );
};

export default LoginForm;